module.exports = "<svg version=\"1.1\" viewBox=\"0 0 32 32\"><path d=\"M0 26h32v4h-32zM4 18h4v6h-4zM10 10h4v14h-4zM16 16h4v8h-4zM22 4h4v20h-4z\"></path></svg>"